import { useMutation } from '@tanstack/react-query';
import { useCustomerService } from '../services/customers.service';
import type { BexioContactMigrationParams } from '../models/bexioContactMigration.model';
import type { BackendErrorResponse } from '@/shared';

/** Runs the Bexio company → person conversion (dry run or real run). */
export function useBexioContactMigration() {
  const service = useCustomerService();

  return useMutation({
    mutationFn: (params: BexioContactMigrationParams) =>
      service.convertBexioCompanyContacts(params),
  });
}

export function getBexioMigrationErrorMessage(error: unknown): string | null {
  if (!error) return null;
  const be = error as BackendErrorResponse | undefined;
  const message = be?.response?.data?.message;
  if (typeof message === 'string' && message.trim()) return message;
  return be?.message || String(error);
}
